var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIdentificationCard = function SvgIconIdentificationCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.822 7.813a3.062 3.062 0 0 0-2.077 5.312l-.088.085a3.06 3.06 0 0 0-.897 2.165 1 1 0 1 0 2 0 1.063 1.063 0 0 1 2.125 0 1 1 0 0 0 2 0 3.06 3.06 0 0 0-.985-2.25 3.063 3.063 0 0 0-2.078-5.312M7.76 10.875a1.062 1.062 0 1 1 2.125 0 1.062 1.062 0 0 1-2.125 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 10.125a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M13.25 13.875a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 3.5A1.75 1.75 0 0 0 2 5.25v13.5c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 18.75V5.25a1.75 1.75 0 0 0-1.75-1.75zm.25 15v-13h16v13z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconIdentificationCard;